import React from "react";
import BreadCrumbBg from "../../assets/landing/img/hero/hero_bg_7_1.png";

const Breadcrumb = ({ title }) => {
  return (
    <div
      className="breadcumb-wrapper background-image"
      style={{ backgroundImage: `url(${BreadCrumbBg})` }}
    >
      <div className="container">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">{title}</h1>
          <ul className="breadcumb-menu">
            <li>
              <a href="/">Trang chủ</a>
            </li>
            <li>{title}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
